export const TEST_IDS = {
  sidebar: "sidebar",
  sidebarNavItem: (name: string) => `sidebar-nav-${name}`,
  header: "header",
  pageTitle: "page-title",
  pageContainer: "page-container",

  searchInput: "search-input",
  filterButton: "filter-button",
  refreshButton: "refresh-button",
  exportButton: "export-button",

  dataTable: "data-table",
  tableRow: (index: number) => `table-row-${index}`,
  tableRowMenu: (index: number) => `table-row-menu-${index}`,
  emptyState: "empty-state",
  loadingState: "loading-state",

  mapContainer: "map-container",
  mapControls: "map-controls",
  mapZoomIn: "map-zoom-in",
  mapZoomOut: "map-zoom-out",
  mapFullscreen: "map-fullscreen",
  mapLayerToggle: "map-layer-toggle",
  mapFilterPanel: "map-filter-panel",
  mapSearchPanel: "map-search-panel",

  modal: "modal",
  modalTitle: "modal-title",
  modalConfirm: "modal-confirm",
  modalCancel: "modal-cancel",
  modalClose: "modal-close",

  formField: (name: string) => `form-field-${name}`,
  formError: (name: string) => `form-error-${name}`,
  formSubmit: "form-submit",

  tourModal: "tour-modal",
  tourSkip: "tour-skip",
  tourNext: "tour-next",

  loginForm: "login-form",
  loginEmail: "login-email",
  loginPassword: "login-password",
  loginSubmit: "login-submit",
} as const;
